module.exports = __webpack_public_path__ + "static/logoHelenaEsperantoAsocio-53576750a835af2d912ec4d732f30e9e.jpg";